import { QuestionEnableWhenObjectType } from "../Questionnaire.types";

export function getQuestionEnableWhenItems(
  enableWhen: QuestionEnableWhenObjectType[] = []
): string[] {
  return enableWhen.map((item) => `questionnaire.${item.id}`);
}
